export const keycloakKeys = {
  all: ['keycloak-orphans'] as const,
  lists: () => [...keycloakKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...keycloakKeys.lists(), filters] as const,
};
